import axios from 'axios';
import { setupInterceptorsTo } from '../Componentes/API/AxiosBuilder';
import { RUTA_API_TRADUCCIONES } from '../Contantes/Constantes';

export default function useTranslationService() {
    const axiosInstance = setupInterceptorsTo(
        axios.create({
            headers: {
                "Content-Type": "application/json",
            },
        })
    );

    const getTranslations = async (status) => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_TRADUCCIONES}/request`,
            params: { status },
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const getTypes = async () => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_TRADUCCIONES}/type`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const getDepartment = async () => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_TRADUCCIONES}/department`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const getReasons = async () => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_TRADUCCIONES}/reason`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const getTranslationsByUserId = async (petitioner_id) => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_TRADUCCIONES}/request/petitioner/${petitioner_id}`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const getTranslationsByStatus = async (status) => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_TRADUCCIONES}/request`,
            params: { status },
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const getTraductors = async () => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_TRADUCCIONES}/traductor`,
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const downloadExcel = async () => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_TRADUCCIONES}/request/excel/export`,
            responseType: 'blob',
        };
        return axiosInstance(config)
        .then(response => response.data)
        .catch(error => ({
            success: false,
            error: error.response?.data || {
                code: 'UNKNOWN_ERROR',
                details: 'An unknown error occurred',
            },
        }));
    };

    const downloadTranslation = async (type, folder, fileName) => {
        const config = {
            method: 'GET',
            url: `${RUTA_API_TRADUCCIONES}/request/download/file/${type}`,
            params: { file: fileName, folder },
            responseType: 'blob',
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const createTranslation = async (translation) => {
        const formData = new FormData();
        Object.entries(translation).forEach(([key, value]) => formData.append(key, value));

        const config = {
            method: 'POST',
            url: `${RUTA_API_TRADUCCIONES}/request`,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const updateTranslationFile = async (id, file) => {
        const formData = new FormData();
        formData.append('requestId', id);
        formData.append('file', file);

        const config = {
            method: 'POST',
            url: `${RUTA_API_TRADUCCIONES}/request/upload/file-corrected`,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    const updateTranslation = async (translation, id) => {
        const formData = new URLSearchParams();

        for (const key in translation) {
            if (translation.hasOwnProperty(key)) {
                formData.append(key, translation[key]);
            }
        }

        const config = {
            method: 'PUT',
            url: `${RUTA_API_TRADUCCIONES}/request/${id}`,
            data: formData.toString(),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };
        return axiosInstance(config)
            .then(response => response.data)
            .catch(error => ({
                success: false,
                error: error.response?.data || {
                    code: 'UNKNOWN_ERROR',
                    details: 'An unknown error occurred',
                },
            }));
    };

    return {
        getTranslations,
        getDepartment,
        getReasons,
        getTraductors,
        getTypes,
        downloadTranslation,
        getTranslationsByUserId,
        updateTranslationFile,
        createTranslation,
        getTranslationsByStatus,
        updateTranslation,
        downloadExcel
    };
}
